// @ts-nocheck
import { httpClient } from '../../../core/network';

class ContractService {
  static fetchContract(contractId) {
    const apiUrl = `/contracts/${contractId}`;
    return httpClient.get(apiUrl);
  }

  static createContract(contractData) {
    const apiUrl = `/companies/${contractData.companyId}/contracts`;
    return httpClient.post(apiUrl, contractData);
  }

  static closeContract(contractId, force = false) {
    const apiUrl = `/contracts/${contractId}`;
    return httpClient.delete(apiUrl, {
      params: { force },
    });
  }

  static activateContract(companyId, contractId) {
    const apiUrl = `/companies/${companyId}/contracts/${contractId}/status`;
    return httpClient.put(apiUrl, {
      status: 'ACTIVE',
    });
  }

  static addUsersToContract(companyId, contractId, userIds) {
    const apiUrl = `/companies/${companyId}/contracts/${contractId}/users`;
    return httpClient.put(apiUrl, userIds);
  }
}

export default ContractService;
